import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { toast } from 'react-toastify'
import { invalidateAiListeningPromptData } from 'src/reactQuery/utils/aiListeningProfileCache'
import {
  AiListeningBrandProfileApiService,
  AiListeningErrorEnvelope,
} from 'src/services/aiListeningApi/brandProfile'

interface UseDeleteAiListeningPromptMutationParams {
  onSuccess?: () => void
}

export const useDeleteAiListeningPromptMutation = ({
  onSuccess,
}: UseDeleteAiListeningPromptMutationParams = {}) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (promptId: string) =>
      AiListeningBrandProfileApiService.deletePrompt(promptId),
    onError: (error: AxiosError<AiListeningErrorEnvelope>) => {
      toast.error(error.response?.data?.error || 'Failed to delete the prompt')
    },
    onSuccess: () => {
      invalidateAiListeningPromptData(queryClient)
      toast.success('Prompt deleted')
      onSuccess?.()
    },
  })
}
